<div class="responsive-card details-card">
  <ng-container *ngIf="!isLoading; else loading">
    <span class="details-card-title" i18n>Plan Overview</span>
    <div class="d-flex flex-column">
      <div class="detail-row">
        <span class="detail-label" i18n>Plan Type</span>
        <div class="detail-value">{{ plan?.employerPlanType?.name }}</div>
      </div>
      <div class="detail-row pt-3">
        <span class="detail-label" i18n>Date of Plan Establishment</span>
        <div class="detail-value">{{ plan?.planEstablishmentDate | date : 'MMM dd, yyyy' }}</div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <lib-loading-shimmer [borderRadius]="'0.5rem'" [height]="'8.5rem'" [width]="'100%'" />
</ng-template>
